if (!customElements.get('draggable-track')) {
  class DraggableTrack extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-draggable-track]');
      this.scrollbar = this.querySelector('[data-product-scrollbar]');
      this.thumb = this.querySelector('[data-product-thumb]');
      this.wrapper = this.closest('.product-list');
      this.prevBtn = this.wrapper?.querySelector('[data-product-prev]');
      this.nextBtn = this.wrapper?.querySelector('[data-product-next]');


      if (!this.track) return;

      this.initScrollbar();
      this.initButtons();

      this._isDown = false;
      this._didDrag = false;
      this._startX = 0;
      this._startScroll = 0;
      this._velocity = 0;
      this._lastX = 0;
      this._lastTime = 0;
      this._rafId = null;

      this.track.addEventListener('dragstart', (e) => e.preventDefault());

      this.track.addEventListener('mousedown', (e) => {
        this._cancelMomentum();
        this._isDown = true;
        this._didDrag = false;
        this._startX = e.pageX;
        this._startScroll = this.track.scrollLeft;
        this._lastX = e.pageX;
        this._lastTime = Date.now();
        this._velocity = 0;
      });

      this.track.addEventListener('mousemove', (e) => {
        if (!this._isDown) return;

        const dx = Math.abs(e.pageX - this._startX);
        if (dx < 6) return;

        if (!this._didDrag) {
          this._didDrag = true;
          this.track.classList.add('is-dragging');
        }

        e.preventDefault();

        const now = Date.now();
        const dt = now - this._lastTime;

        if (dt > 0) {
          this._velocity = (this._lastX - e.pageX) / dt;
        }

        this._lastX = e.pageX;
        this._lastTime = now;

        const walk = (e.pageX - this._startX) * 1.5;
        this.track.scrollLeft = this._startScroll - walk;
      });

      const stopDrag = () => {
        if (!this._isDown) return;

        this._isDown = false;
        this.track.classList.remove('is-dragging');

        if (this._didDrag && Math.abs(this._velocity) > 0.3) {
          this._startMomentum();
        }
      };

      this.track.addEventListener('mouseup', stopDrag);
      this.track.addEventListener('mouseleave', stopDrag);

      this.track.addEventListener(
        'click',
        (e) => {
          if (this._didDrag) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        },
        true
      );

      this.track.addEventListener('scroll', () => {
        this.updateThumb();
        this.updateButtons();
      });

      window.addEventListener('resize', () => {
        this.updateThumbSize();
        this.updateThumb();
        this.updateButtons();
      });
    }
    initButtons() {
        if (!this.prevBtn && !this.nextBtn) return;
        this.updateButtons();

        const getStep = () => {
            const firstItem = this.track.firstElementChild;
            return firstItem ? firstItem.getBoundingClientRect().width + 
            parseFloat(getComputedStyle(this.track).columnGap || 0)
            : this.track.clientWidth * 0.8;
        };

        this.prevBtn?.addEventListener('click', () => {
            this._cancelMomentum();
            this.track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        this.nextBtn?.addEventListener('click', () => {
            this._cancelMomentum();
            console.log("123");
            this.track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
    }

    updateButtons() {
        if (!this.prevBtn && !this.nextBtn) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const atStart = this.track.scrollLeft <= 1;
        const atEnd = this.track.scrollLeft >= maxScroll - 1;

        if (this.prevBtn) {
            this.prevBtn.disabled = atStart;
            this.prevBtn.classList.toggle('is-disabled', atStart);
        }
        if (this.nextBtn) {
            this.nextBtn.disabled = atEnd;
            this.nextBtn.classList.toggle('is-disabled', atEnd);
        }
    }

    initScrollbar() {
      if (!this.scrollbar || !this.thumb) return;

      this.updateThumbSize();
      this.updateThumb();

      let isThumbDragging = false;
      let startX = 0;
      let startLeft = 0;

      this.thumb.addEventListener('mousedown', (e) => {
        isThumbDragging = true;
        startX = e.clientX;
        startLeft = this.thumb.offsetLeft;

        document.body.classList.add('is-dragging-thumb');
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isThumbDragging) return;

        const delta = e.clientX - startX;

        const maxThumbMove =
          this.scrollbar.clientWidth - this.thumb.offsetWidth;

        const newLeft = Math.max(
          0,
          Math.min(startLeft + delta, maxThumbMove)
        );

        const scrollRatio = newLeft / maxThumbMove;

        this.track.scrollLeft =
          scrollRatio *
          (this.track.scrollWidth - this.track.clientWidth);
      });

      document.addEventListener('mouseup', () => {
        isThumbDragging = false;
        document.body.classList.remove('is-dragging-thumb');
      });
    }

    updateThumbSize() {
      if (!this.scrollbar || !this.thumb) return;

      const ratio =
        this.track.clientWidth / this.track.scrollWidth;

      const width = Math.max(
        this.scrollbar.clientWidth * ratio,
        40
      );

      this.thumb.style.width = `${width}px`;
    }

    updateThumb() {
      if (!this.scrollbar || !this.thumb) return;

      const maxScroll =
        this.track.scrollWidth - this.track.clientWidth;

      if (maxScroll <= 0) {
        this.thumb.style.transform = 'translateX(0)';
        return;
      }

      const maxThumbMove =
        this.scrollbar.clientWidth - this.thumb.offsetWidth;

      const thumbX =
        (this.track.scrollLeft / maxScroll) * maxThumbMove;

      this.thumb.style.transform = `translateX(${thumbX}px)`;
    }

    _startMomentum() {
      let v = this._velocity * 800;
      const friction = 0.95;

      const step = () => {
        v *= friction;

        if (Math.abs(v) < 0.5) return;

        this.track.scrollLeft += v / 60;
        this._rafId = requestAnimationFrame(step);
      };

      this._rafId = requestAnimationFrame(step);
    }

    _cancelMomentum() {
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }
  }

  customElements.define('draggable-track', DraggableTrack);
}